// extracted by mini-css-extract-plugin
module.exports = {"Oblong":"Description_Oblong__3J9fT"};